import { Grid } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyCompReportSettings } from '../../arc/models/arc-epi-props';
import { MapContext } from '../models';
import { domoUrl } from './embed';



export function RegionDioReport() {
	const mapContext = useSelector<TcsmStates, MapContext>(state => state?.clergyCompReportState?.mapContext);
	const settings = useSelector<TcsmStates, ClergyCompReportSettings>(state => state.epiProps.clergyCompReportSettingsState.epiContent);
	return (
		<>
			<h2>{settings?.hisCompLabel}</h2>

			<iframe
				title="global-median-comp"
				src={`${domoUrl}/api/card?reportName=${settings?.globalClergyMedianCompReportId || 'IRjR6Jy'}`}
				name={settings?.globalClergyMedianCompReportId || 'IRjR6Jy'}
				data-group='filtered'
				id='global-median-comp'
				width='445' height='290'
				marginHeight={0}
				marginWidth={0}
				frameBorder={0}
			/>
			<iframe
				title="global-clergy-total"
				src={`${domoUrl}/api/card?reportName=${settings?.globalClergyTotalReportId || 'IRkRXMJ'}`}
				name={settings?.globalClergyTotalReportId || 'IRkRXMJ'}
				data-group='filtered'
				id='global-clergy-total'
				width='445' height='290'
				marginHeight={0}
				marginWidth={0}
				frameBorder={0}
			/>
			{
				mapContext === MapContext.INTERNATIONAL &&
				<Grid item xs={12} >
					<WysiwygWithReactLink className='text' content={settings?.medianCompensationHelperTexts} />
				</Grid>
			}
		</>
	);
}